import { sendStructEvent } from '../../api';

interface PayloadModel {
    eventCategory: string;
    eventAction: string;
    eventLabel: string;
    eventProperty: {
        store: string;
        locale: string;
        location: 'PDP' | 'checkout';
        current_url: string;
        product_sku: string;
        variant_sku: string;
        category: string;
        sub_category: string;
        step?: string;
        order_id?: string;
    };
}

export const sendViewPurchaseOptionTooltipEvent = (payload: PayloadModel): void => {
    const { eventCategory, eventAction, eventLabel, eventProperty } = payload;

    sendStructEvent({
        eventCategory,
        eventAction,
        eventLabel,
        eventProperty,
    });
};
